import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import FAQAccordionItem from '@/components/FAQAccordionItem';

const H2 = 'font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-6';

export default function ServiceDetailExtras({ page }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <section className="mb-16">
        <h2 className={H2}>Frequently asked questions</h2>
        <div className="space-y-4">
          {page.faqs.map((faq, i) => (
            <FAQAccordionItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </div>
      </section>

      <section>
        <h2 className={H2}>Related ventures & articles</h2>
        <ul className="grid sm:grid-cols-2 gap-4">
          {page.related.map((link) => (
            <li key={link.label}>
              <Link
                to={link.to}
                className="group flex items-center justify-between gap-3 h-full rounded-2xl border border-border/30 bg-card/30 backdrop-blur-sm p-5 hover:border-primary/40 transition-all duration-300">
                <span className="text-sm font-inter font-medium text-foreground group-hover:text-primary transition-colors">{link.label}</span>
                <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-primary shrink-0" />
              </Link>
            </li>
          ))}
          <li>
            <Link to="/services" className="group flex items-center justify-between gap-3 h-full rounded-2xl border border-border/30 bg-card/30 backdrop-blur-sm p-5 hover:border-primary/40 transition-all duration-300">
              <span className="text-sm font-inter font-medium text-foreground group-hover:text-primary transition-colors">All digital services in Dubai & the UAE</span>
              <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-primary shrink-0" />
            </Link>
          </li>
        </ul>
      </section>
    </>
  );
}